import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useContext } from 'react';
import { UserContext } from 'components/UserContext';
import { ReviewOpinions } from 'components/Admin/ReviewOpinions';

export const AdminPage = () => {
  const { isLoading, user } = useContext(UserContext);

  if (isLoading) {
    return null;
  }

  return (
    <Container>
      <Row>
        <Col>
          <div className="alert alert-danger">어드민입니다.</div>
          {!user && '유저가 없음'}
          {user && user.email !== 'nscorpio16@gmail.com' ? (
            `어드민만 접근 가능합니다. ${user.email}`
          ) : (
            <ReviewOpinions />
          )}
        </Col>
      </Row>
    </Container>
  )
}
